module.exports = __webpack_public_path__ + "73008443e4e7b8eaa99ae7778f1f40ac.MP3";